const isPreferredCarrierTier = (tier) => tier === "ADVANTAGE";
export function getCarrierCombinations(segments) {
    const carrierCombinations = new Map();
    let hasPreferredCarrier = false;
    for (const segment of segments) {
        for (const leg of segment.legs) {
            const carrierInfo = leg.flightInfo?.carrierInfo;
            if (!hasPreferredCarrier && isPreferredCarrierTier(carrierInfo?.tier?.type)) {
                hasPreferredCarrier = true;
            }
            const marketingCarrierCode = carrierInfo?.marketingCarrier;
            const operatingCarrierCode = carrierInfo?.operatingCarrier;
            if (!marketingCarrierCode || !operatingCarrierCode)
                continue;
            const key = marketingCarrierCode + "-" + operatingCarrierCode;
            if (carrierCombinations.has(key))
                continue;
            let marketingCarrier = null;
            let operatingCarrier = null;
            for (const carrier of leg.carriersData) {
                if (carrier.code === marketingCarrierCode)
                    marketingCarrier = carrier;
                if (carrier.code === operatingCarrierCode)
                    operatingCarrier = carrier;
            }
            if (marketingCarrier && operatingCarrier) {
                carrierCombinations.set(key, { marketingCarrier, operatingCarrier });
            }
        }
    }
    if (!hasPreferredCarrier)
        return [];
    const combinations = Array.from(carrierCombinations.values());
    const selfOperatedMarketingCarriers = new Set(combinations
        .filter(({ marketingCarrier, operatingCarrier }) => marketingCarrier.code === operatingCarrier.code)
        .map(({ marketingCarrier }) => marketingCarrier.code));
    return combinations.filter(({ marketingCarrier, operatingCarrier }) => marketingCarrier.code === operatingCarrier.code || !selfOperatedMarketingCarriers.has(marketingCarrier.code));
}
export function getMarketingCarriers(segments) {
    const marketingCarriers = new Map();
    let hasPreferredCarrier = false;
    for (const segment of segments) {
        for (const leg of segment.legs) {
            const carrierInfo = leg.flightInfo?.carrierInfo;
            if (!hasPreferredCarrier && isPreferredCarrierTier(carrierInfo?.tier?.type)) {
                hasPreferredCarrier = true;
            }
            const marketingCarrierCode = carrierInfo?.marketingCarrier;
            if (!marketingCarrierCode || marketingCarriers.has(marketingCarrierCode))
                continue;
            const marketingCarrier = leg.carriersData.find(({ code }) => code === marketingCarrierCode);
            if (marketingCarrier)
                marketingCarriers.set(marketingCarrierCode, marketingCarrier);
        }
    }
    return hasPreferredCarrier ? Array.from(marketingCarriers.values()) : [];
}
